// What the weapons look like in a figure's hands.
//
// Every routine draws in the same local frame: the HAND is at (0,0),
// +x points down the aim, and one unit is the figure's body radius.
// So a shape never knows where the player is, which way they face, or
// how big they are — sprites.js has already put the canvas in the
// right place and orientation. Mirroring is handled there too, which
// is why nothing here worries about facing left.
//
// These are drawn at ~24px tall in the real game, so the only thing
// that survives is the SILHOUETTE. Every one of them is a couple of
// blocks and a triangle; detail below about 2px is a waste of the
// reader's time and mine.
//
// `back` is how far the shape extends behind the hand, in body radii.
// It's what a two-handed grip measures from (see sprites.js), so it
// has to be honest about the drawing, not a guess.

const rect = (g, x, y, w, h) => g.fillRect(x, y, w, h);

// Shoop Da Whoop: a fat blaster with a flared muzzle. Yellow because
// the beam is.
function blaster(g, r, ink) {
    g.fillStyle = "#2a3550";
    rect(g, -0.32 * r, -0.16 * r, 1.05 * r, 0.32 * r);  // body
    g.fillStyle = "#1a2233";
    rect(g, -0.32 * r, 0.02 * r, 0.4 * r, 0.3 * r);     // grip under the hand
    g.fillStyle = "#ffe24a";
    g.beginPath();                                       // flared muzzle
    g.moveTo(0.7 * r, -0.16 * r);
    g.lineTo(1.02 * r, -0.3 * r);
    g.lineTo(1.02 * r, 0.3 * r);
    g.lineTo(0.7 * r, 0.16 * r);
    g.closePath();
    g.fill();
}
blaster.back = 0.32;

// Poptart Creature: a toaster. Two slots, and a tart peeking out of
// the front one.
function toaster(g, r, ink) {
    g.fillStyle = "#8f9bb3";
    rect(g, -0.42 * r, -0.34 * r, 0.95 * r, 0.62 * r);
    g.fillStyle = "#5a6478";
    rect(g, -0.3 * r, -0.34 * r, 0.24 * r, 0.08 * r);   // slots, seen side-on
    rect(g, 0.08 * r, -0.34 * r, 0.24 * r, 0.08 * r);
    g.fillStyle = "#ff5bd0";                             // a tart, mid-launch
    rect(g, 0.42 * r, -0.5 * r, 0.34 * r, 0.24 * r);
    g.fillStyle = "#3a4256";                             // lever
    rect(g, -0.5 * r, -0.18 * r, 0.1 * r, 0.3 * r);
}
toaster.back = 0.5;

// Doge Bork: a megaphone.
function megaphone(g, r, ink) {
    g.fillStyle = "#2a3550";
    rect(g, -0.3 * r, -0.1 * r, 0.5 * r, 0.2 * r);
    g.fillStyle = "#e7b45a";
    g.beginPath();
    g.moveTo(0.2 * r, -0.12 * r);
    g.lineTo(0.95 * r, -0.42 * r);
    g.lineTo(0.95 * r, 0.42 * r);
    g.lineTo(0.2 * r, 0.12 * r);
    g.closePath();
    g.fill();
}
megaphone.back = 0.3;

// Ceiling Cat: a carrier with a barred door and two eyes waiting
// inside.
function carrier(g, r, ink) {
    g.fillStyle = "#6b5a44";
    rect(g, -0.34 * r, -0.3 * r, 0.8 * r, 0.6 * r);
    g.fillStyle = "#241d15";
    rect(g, 0.16 * r, -0.22 * r, 0.3 * r, 0.44 * r);    // the door
    g.fillStyle = "#ffe24a";                             // ...and what's behind it
    rect(g, 0.24 * r, -0.1 * r, 0.07 * r, 0.07 * r);
    rect(g, 0.36 * r, -0.1 * r, 0.07 * r, 0.07 * r);
    g.fillStyle = "#8f7a5c";                             // handle
    rect(g, -0.2 * r, -0.42 * r, 0.44 * r, 0.09 * r);
}
carrier.back = 0.34;

// This Is Fine: a jerrycan with a nozzle. The fire it drops is the
// zone.
function jerrycan(g, r, ink) {
    g.fillStyle = "#c0392b";
    rect(g, -0.4 * r, -0.3 * r, 0.72 * r, 0.62 * r);
    g.fillStyle = "#8d2a20";
    rect(g, -0.4 * r, -0.06 * r, 0.72 * r, 0.08 * r);   // seam
    g.fillStyle = "#3a4256";
    rect(g, 0.32 * r, -0.1 * r, 0.62 * r, 0.13 * r);    // nozzle
    g.fillStyle = "#ffb03a";
    rect(g, 0.94 * r, -0.13 * r, 0.1 * r, 0.19 * r);    // pilot light
}
jerrycan.back = 0.4;

// Cereal Guy: the bowl, tipped forward mid-spit. Milk and Os come out
// of it.
function cerealbowl(g, r, ink) {
    g.fillStyle = "#e8edf5";
    g.beginPath();                                       // bowl, mouth forward
    g.moveTo(-0.44 * r, -0.36 * r);
    g.lineTo(0.34 * r, -0.5 * r);
    g.lineTo(0.16 * r, 0.34 * r);
    g.lineTo(-0.34 * r, 0.24 * r);
    g.closePath();
    g.fill();
    g.fillStyle = "#f3e6c4";                             // milk
    rect(g, -0.3 * r, -0.3 * r, 0.56 * r, 0.16 * r);
    g.fillStyle = "#e8b23a";                             // an O on the way out
    g.beginPath(); g.arc(0.44 * r, -0.4 * r, 0.11 * r, 0, 7); g.fill();
    g.fillStyle = "#0f1420";
    g.beginPath(); g.arc(0.44 * r, -0.4 * r, 0.045 * r, 0, 7); g.fill();
}
cerealbowl.back = 0.44;

// Stonks: the chart. A board with the line only going one way.
function chart(g, r, ink) {
    g.fillStyle = "#101a2c";
    rect(g, -0.4 * r, -0.44 * r, 1.0 * r, 0.86 * r);
    g.strokeStyle = "#2a3550";
    g.lineWidth = Math.max(1, 0.04 * r);
    g.strokeRect(-0.4 * r, -0.44 * r, 1.0 * r, 0.86 * r);
    // the line: up and to the right, forever
    g.strokeStyle = "#4dffa6";
    g.lineWidth = Math.max(1.4, 0.09 * r);
    g.lineCap = "round";
    g.beginPath();
    g.moveTo(-0.28 * r, 0.28 * r);
    g.lineTo(-0.02 * r, 0.0 * r);
    g.lineTo(0.16 * r, 0.12 * r);
    g.lineTo(0.48 * r, -0.32 * r);
    g.stroke();
    g.fillStyle = "#4dffa6";                             // arrowhead
    g.beginPath();
    g.moveTo(0.52 * r, -0.38 * r);
    g.lineTo(0.52 * r, -0.06 * r);
    g.lineTo(0.2 * r, -0.38 * r);
    g.closePath();
    g.fill();
}
chart.back = 0.4;

// Me Gusta: the face, on a stick. You are holding the feeling, not a
// gun.
function mask(g, r, ink) {
    g.fillStyle = "#6b5a44";
    rect(g, -0.34 * r, -0.05 * r, 0.5 * r, 0.1 * r);     // handle
    g.fillStyle = "#f0e4cf";
    g.beginPath(); g.arc(0.44 * r, 0, 0.42 * r, 0, Math.PI * 2); g.fill();
    g.strokeStyle = "#1a1a1a";
    g.lineWidth = Math.max(1, 0.05 * r);
    g.beginPath(); g.arc(0.44 * r, 0, 0.42 * r, 0, Math.PI * 2); g.stroke();
    gustaFace(g, 0.44 * r, 0, 0.42 * r);
}
mask.back = 0.34;

// The Me Gusta face itself — reused by the projectile, so the thing
// you fire is visibly the thing you're holding.
export function gustaFace(g, cx, cy, rad) {
    g.strokeStyle = "#1a1a1a";
    g.fillStyle = "#1a1a1a";
    g.lineWidth = Math.max(0.8, rad * 0.1);
    // heavy-lidded eyes, looking sideways
    g.beginPath();
    g.moveTo(cx - rad * 0.62, cy - rad * 0.3);
    g.quadraticCurveTo(cx - rad * 0.3, cy - rad * 0.62, cx - rad * 0.02, cy - rad * 0.3);
    g.moveTo(cx + rad * 0.1, cy - rad * 0.3);
    g.quadraticCurveTo(cx + rad * 0.42, cy - rad * 0.62, cx + rad * 0.7, cy - rad * 0.3);
    g.stroke();
    g.beginPath();
    g.arc(cx - rad * 0.3, cy - rad * 0.22, rad * 0.1, 0, 7);
    g.arc(cx + rad * 0.4, cy - rad * 0.22, rad * 0.1, 0, 7);
    g.fill();
    // the smirk: wide, one-sided, deeply pleased about something
    g.beginPath();
    g.moveTo(cx - rad * 0.55, cy + rad * 0.3);
    g.quadraticCurveTo(cx + rad * 0.1, cy + rad * 0.9, cx + rad * 0.72, cy + rad * 0.12);
    g.stroke();
}

// Dodgeball Launcher: a stubby air-cannon with a red rubber ball loaded at the muzzle.
function ballgun(g, r, ink) {
    g.fillStyle = "#2a3550";
    rect(g, -0.34 * r, -0.15 * r, 0.8 * r, 0.3 * r);     // barrel
    g.fillStyle = "#1a2233";
    rect(g, -0.34 * r, 0.05 * r, 0.32 * r, 0.28 * r);    // grip under the hand
    g.fillStyle = "#c0392b";                              // the dodgeball, loaded
    g.beginPath(); g.arc(0.66 * r, 0, 0.3 * r, 0, Math.PI * 2); g.fill();
    g.strokeStyle = "#7d241b"; g.lineWidth = Math.max(1, 0.05 * r);
    g.beginPath(); g.moveTo(0.4 * r, 0); g.lineTo(0.92 * r, 0); g.stroke();  // rubber seam
}
ballgun.back = 0.34;

// Fish Launcher: you are holding a fish by the tail, because of course you are. Body
// forward down the aim, the same gormless silhouette the projectile flies with.
function fishgun(g, r, ink) {
    g.fillStyle = "#4a90c2";
    g.beginPath();                                        // tail fin, gripped end (−x)
    g.moveTo(-0.28 * r, 0);
    g.lineTo(-0.52 * r, -0.26 * r);
    g.lineTo(-0.44 * r, 0);
    g.lineTo(-0.52 * r, 0.26 * r);
    g.closePath(); g.fill();
    g.beginPath();                                        // dorsal fin
    g.moveTo(0.05 * r, -0.2 * r);
    g.lineTo(0.26 * r, -0.42 * r);
    g.lineTo(0.36 * r, -0.16 * r);
    g.closePath(); g.fill();
    g.beginPath();                                        // teardrop body
    g.ellipse(0.28 * r, 0, 0.6 * r, 0.32 * r, 0, 0, Math.PI * 2);
    g.fill();
    g.fillStyle = "#0b1a2b";                              // eye + downturned mouth
    g.beginPath(); g.arc(0.66 * r, -0.08 * r, 0.08 * r, 0, Math.PI * 2); g.fill();
    g.strokeStyle = "#0b1a2b"; g.lineWidth = Math.max(1, 0.05 * r);
    g.beginPath(); g.arc(0.86 * r, -0.05 * r, 0.11 * r, 0.5, 1.9); g.stroke();
}
fishgun.back = 0.52;

// Trowel: a mason's hand trowel — a short shaft and a rounded steel blade. You build with it.
function trowel(g, r, ink) {
    g.fillStyle = "#5a6478";
    rect(g, -0.3 * r, -0.06 * r, 0.4 * r, 0.12 * r);     // shaft under the hand
    g.fillStyle = "#c9d2e0";
    g.beginPath();                                        // steel blade, a rounded triangle
    g.moveTo(0.08 * r, -0.2 * r);
    g.lineTo(0.86 * r, 0);
    g.lineTo(0.08 * r, 0.2 * r);
    g.closePath(); g.fill();
}
trowel.back = 0.3;

// Mallet: a wooden mallet — a banded head on a shaft. You break blocks with it.
function mallet(g, r, ink) {
    g.fillStyle = "#3a4256";
    rect(g, -0.35 * r, -0.06 * r, 0.85 * r, 0.12 * r);   // shaft
    g.fillStyle = "#8a5a2b";
    rect(g, 0.5 * r, -0.34 * r, 0.34 * r, 0.68 * r);     // wooden head
    g.fillStyle = "#6b4420";
    rect(g, 0.5 * r, -0.34 * r, 0.06 * r, 0.68 * r);     // banding, near and far
    rect(g, 0.78 * r, -0.34 * r, 0.06 * r, 0.68 * r);
}
mallet.back = 0.35;

// Grenade Launcher: a stubby green launcher. The octagonal barrel is faked with three horizontal green
// bands — lit on top, shadowed below — so the flat rectangles read as a rounded, faceted tube; an orange
// muzzle sits at the business end. (Set 13.)
function grenadelaunch(g, r, ink) {
    g.fillStyle = "#2b3a20";
    rect(g, -0.34 * r, 0.05 * r, 0.34 * r, 0.34 * r);     // grip beneath the hand
    const bx = -0.3 * r, bw = 1.02 * r;                   // the three barrel facets, top-lit to bottom-shadowed
    g.fillStyle = "#7ba24a"; rect(g, bx, -0.24 * r, bw, 0.15 * r);
    g.fillStyle = "#5c8232"; rect(g, bx, -0.09 * r, bw, 0.17 * r);
    g.fillStyle = "#3f5a21"; rect(g, bx, 0.08 * r, bw, 0.15 * r);
    g.fillStyle = "#ff8a1e";                              // orange muzzle at the front
    rect(g, 0.72 * r, -0.24 * r, 0.17 * r, 0.47 * r);
}
grenadelaunch.back = 0.34;

export const WEAPON_ART = { blaster, toaster, megaphone, carrier, jerrycan, cerealbowl, chart, mask, ballgun, fishgun, trowel, mallet, grenadelaunch };

// Draw a weapon's art centred inside a box, for the HUD's weapon carousel — the same
// silhouettes the figures hold, shrunk to a chip. In-hand the art is drawn in body radii
// with the grip at the origin and the barrel reaching out to +x (roughly -0.5r..+1.05r
// wide, ±0.5r tall), so it's NOT centred on its own box: we scale so the ~1.55r span fits
// `size` and nudge left by half the art's forward reach to sit it in the middle.
export function drawWeaponIcon(g, shape, cx, cy, size, ink) {
    const art = WEAPON_ART[shape];
    if (!art) return;
    const r = size / 1.7;             // 1.55r of art + a little air
    g.save();
    g.translate(cx - 0.27 * r, cy);   // 0.27r ≈ the centre of the art's x-extent
    art(g, r, ink);
    g.restore();
}

// How far a shape reaches behind the hand — where a second hand can
// grip it.
export const artBack = (shape) => (WEAPON_ART[shape] && WEAPON_ART[shape].back) || 0.3;
